export default "__VITE_ASSET__CzEOTApT__"